import {NotifyProps} from "./interface";

export type TranslateFn = (
    keys: string[],
    format?: Record<string, any>
) => Promise<Record<string, string>>;

let globalTranslateFn: TranslateFn | undefined;

/**
 * Notifier için global çeviri fonksiyonunu ayarlar.
 */
export const setNotifierTranslateFn = (fn?: TranslateFn) => {
    globalTranslateFn = fn;
};

/**
 * Title ve message için çeviri yapar.
 */
export async function resolveI18n(
    title: string,
    message: string,
    i18n?: NotifyProps["i18n"]
): Promise<{ title: string; message: string }> {
    const notTranslateAll = i18n?.notTranslate === true;
    const tf = i18n?.translateFn ?? globalTranslateFn;

    if (notTranslateAll || !tf) {
        return { title, message };
    }

    try {
        const map = await tf([title, message], i18n?.formatValue);
        const outTitle = i18n?.notTranslateTitle ? title : (map[title] ?? title);
        const outMessage = i18n?.notTranslateMessage ? message : (map[message] ?? message);
        return { title: outTitle, message: outMessage };
    } catch {
        return { title, message };
    }
}
